import type { OrganizationMember, User } from '../types/api';

export const FIELD_OFFICER_ROLE_NAME = 'field_officer';

/**
 * True when the member holds the field-officer role — via the legacy `role`
 * column or a `memberRoles[]` link. Mirrors the backend dispatch check, which
 * only accepts `field_officer` members of the dispatch org.
 */
export function isFieldOfficerMember(member: OrganizationMember): boolean {
    const names = [
        member.role?.name,
        ...(member.memberRoles ?? []).map((link) => link.role?.name),
    ];
    return names.includes(FIELD_OFFICER_ROLE_NAME);
}

/** Deduped field-officer users from an org-member payload, for assignee pickers. */
export function fieldOfficerUsers(members: OrganizationMember[]): User[] {
    const byId = new Map<string, User>();
    for (const member of members) {
        if (member.user && isFieldOfficerMember(member) && !member.user.isPlatformAdmin) {
            byId.set(member.user.id, member.user);
        }
    }
    return [...byId.values()];
}
